import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import styles from "./FAQsSectionStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Accordion from "components/Accordion/Accordion.js";
import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(styles);

function parseBold(text) {
  const parts = text.split(/(\*\*.+?\*\*)/g);
  return parts.map((part, index) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={index}>{part.slice(2, -2)}</strong>
    ) : (
      part
    )
  );
}

export default function FAQsSection({ id, t }) {
  const classes = useStyles();

  return (
    <ContainerFullHeight id={id} bgColor="white" paddingTop="50px" paddingBottom="200px">
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={8} md={8}>
            <h3 className={classes.title}>{t("faqsSectionTitle")}</h3>
            <Accordion
              activeColor="info"
              collapses={[
                {
                  title: <Typography className={classes.title}>{t("howToGetTitle")}</Typography> ,
                  content: <Typography className={classes.content}>{t("howToGetSubtitle")}</Typography>,
                },
                {
                  title: <Typography className={classes.title}>{t("transportTitle")}</Typography>,
                  content: (
                    <>
                    <Typography className={classes.content}>{parseBold(t("transportSubtitle"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("transportSubtitle1"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("transportSubtitle2"))}</Typography>
                    </>
                  ),
                },
                {
                  title: <Typography className={classes.title}>{t("moneyTitle")}</Typography>,
                  content: (
                    <>
                    <Typography className={classes.content}>{parseBold(t("moneySubtitle"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("moneySubtitle1"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("moneySubtitle2"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("moneySubtitle3"))}</Typography>
                    <br/>
                    <Typography className={classes.content}>{parseBold(t("moneySubtitle4"))}</Typography>
                    </>
                  ),
                },
                {
                  title: <Typography className={classes.title}>{t("weatherTitle")}</Typography>,
                  content: <Typography className={classes.content}>{t("weatherSubtitle")}</Typography>,
                },
                {
                  title: <Typography className={classes.title}>{t("comeAloneTitle")}</Typography>,
                  content: <Typography className={classes.content}>{parseBold(t("comeAloneSubtitle"))}</Typography>,
                },
                {
                  title: <Typography className={classes.title}>{t("languageTitle")}</Typography>,
                  content: <Typography className={classes.content}>{t("languageSubtitle")}</Typography>,
                },
                {
                  title: <Typography className={classes.title}>{t("bilingualTitle")}</Typography>,
                  content: <Typography className={classes.content}>{parseBold(t("bilingualSubtitle"))}</Typography>,
                },
                {
                  title: <Typography className={classes.title}>{t("ticketTitle")}</Typography>,
                  content: <Typography className={classes.content}>{parseBold(t("ticketSubtitle"))}</Typography>,
                },
              ]}
            />
          </GridItem>
        </GridContainer>
      </div>
    </ContainerFullHeight>
  );
}
